export default function (app) {
	app.directive('fixedTextArea', function () {
		return {
			scope: {
				text: '='
			},
			restrict: 'A',
			require: 'ngModel',
			link: function (scope) {
				let textToFix = scope.text;
				scope.$watch('text', function (newValue, oldValue) {
					if (newValue.length < textToFix.length) {
						scope.text = textToFix;
					} else if (newValue.substring(0,textToFix.length) !== textToFix) {
						scope.text = oldValue;
					} else {
						scope.text = newValue;
					}
				})
			}
		};
	});
};
